module.exports = __webpack_public_path__ + "static/img/MERCEDES.c382981.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/MERCEDES.png
// module id = 2gNa
// module chunks = 1